// extracted by mini-css-extract-plugin
export default {"nftDescription":"MintIdShowContainer_nftDescription__hb5xC","nftCartItems":"MintIdShowContainer_nftCartItems__lD0c0","nftCartItem":"MintIdShowContainer_nftCartItem__bdT94"};